import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  Output,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import {
  AddressSummary,
  AddressSummaryService
} from "../../../../../../../common/services/api/resources/addressSummary/address-summary.service";
import { AdvVoicemailboxWithExt, VoicemailAdvancedInfo } from "../../../admin-voicemail-types";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-admin-voicemail-advanced-view",
  templateUrl: "./admin-voicemail-advanced-view.component.html",
  styleUrls: ["../../admin-voicemail-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminVoicemailAdvancedViewComponent implements OnChanges, OnDestroy {
  @Input() voicemail!: AdvVoicemailboxWithExt;
  @Input() lessThanMediumBreakpoint!: boolean;
  @Output() editPanel = new EventEmitter<void>();

  voicemailAdvancedInfo!: VoicemailAdvancedInfo;
  E2eLocators = E2eLocators;
  sipAddress!: string;
  transferAddress!: AddressSummary | undefined;

  private unsubscriber = new Subscription();

  constructor(private addressSummaryService: AddressSummaryService) {}

  ngOnChanges() {
    this.voicemailAdvancedInfo = {
      sayCallerId: this.voicemail.sayCallerId,
      sayDateTime: this.voicemail.sayDateTime,
      sayDuration: this.voicemail.sayDuration,
      timezone: this.voicemail.timezone,
      extensionsList: this.voicemail.extensions,
      sipAddressUsername: this.voicemail.voicemailboxAddress?.username || "",
      transferAddress: this.voicemail.transferAddress
        ? this.voicemail.transferAddress.username + "@" + this.voicemail.transferAddress.domain
        : "",
      pagerNumber: this.voicemail.pager
    };

    this.sipAddress = this.voicemailAdvancedInfo.sipAddressUsername
      ? this.voicemailAdvancedInfo.sipAddressUsername + "@" + this.voicemail.domain
      : "n/a";

    this.unsubscriber.add(
      this.addressSummaryService.orgState.pipe(take(1)).subscribe(addressSummary => {
        this.transferAddress = addressSummary.find(
          address => address.aor === this.voicemailAdvancedInfo.transferAddress
        );
      })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  togglePanel(): void {
    this.editPanel.emit();
  }
}
